import { render } from "./post-smtp-widget.vue?vue&type=template&id=2083de04&scoped=true"
import script from "./post-smtp-widget.vue?vue&type=script&lang=js"
export * from "./post-smtp-widget.vue?vue&type=script&lang=js"

import "./post-smtp-widget.vue?vue&type=style&index=0&id=2083de04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2083de04"],['__file',"src/components/post-smtp-widget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2083de04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2083de04', __exports__)) {
    api.reload('2083de04', __exports__)
  }
  
  module.hot.accept("./post-smtp-widget.vue?vue&type=template&id=2083de04&scoped=true", () => {
    api.rerender('2083de04', render)
  })

}


export default __exports__